<template>
<div>
  <!-- HEADER TITULO -->
  <div class="titulo-contenido">
      <h1>
          <span class="negrita">NOTIFICACIONES POR ESTRADOS</span>
      </h1>

  </div>
  <!--  -->
  <div class="container">
      <div class="row">
        <div class="col-md-12">
          <boton-atras :nombre_ruta="'Home'"/>
        </div>
        <div class="container"> <!-- contenedor_padre-->
          <div class="contenido-texto col-md-12">
            <p>De conformidad al artículo 139 del Código Fiscal de la Federación vigente, las notificaciones por estrados se realizarán publicando el documento que se pretenda notificar durante diez días en la página electrónica que al efecto establezcan las autoridades fiscales; dicho plazo se contará a partir del día siguiente a aquél en que el documento fue publicado; la autoridad dejará constancia de ello en el expediente respectivo. En estos casos, se tendrá como fecha de notificación la del decimoprimer día contado a partir del día siguiente a aquél en el que se hubiera publicado el documento.</p>
            <p>Para efectos del artículo 107 fracción III del Código de la Hacienda Pública para el Estado de Chiapas vigente, las notificaciones por estrados se efectuaran fijando durante seis días el documento que se pretenda notificar en un sitio abierto al público de las oficinas de la autoridad que efectúe la notificación y publicando el documento citado, durante el mismo plazo, en la página electrónica que al efecto establezca la Secretaría; dicho plazo se contará a partir del día siguiente a aquél en que el documento fue fijado o publicado según corresponda; la autoridad dejará constancia de ello en el expediente respectivo. En estos casos, se tendrá como fecha de notificación la del séptimo día contado a partir del día siguiente a aquél en el que se hubiera fijado o publicado el documento.</p>
            <p>En cumplimiento a la disposición legal citada, se notifica lo siguiente:</p>
          </div>
            <div class="col-md-12">
                 <notificacionesTable :documentos="data" />
            </div>
        </div>

      </div>
      <span v-html="fecha_actualizacion"></span>
  </div>
</div>
</template>
<script>
// import cardsMenu from '../../../components/cardsMenu.vue';
import mapFun from "@/common/map-fn-types.js";
import mixin from "@/mixins/mixin.js";
import Notificaciones from "@/services/notificaciones/notificacionesPorEstrados.js"
import botonAtras from '../button-atras';
import notificacionesTable from '../../components/notificacionesTable.vue'
const notificaciones_Service = new Notificaciones();
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
name: 'notificacionesPorEstrados',
components: {botonAtras, notificacionesTable},
data(){
  return {
    data: [],
    fecha_actualizacion:''
  };
},
  async created(){
    this.getNotificaionesEstrado();
  },
  mixins: [mixin, DateFormat],
  methods:{
    async getNotificaionesEstrado(){
        try {
            const response = await notificaciones_Service.getNotificacionesPorEstrados(mapFun.notificacionesPorEstrados);
            // console.log('response', response)
            this.data = response.reverse();
            console.log(this.data);
            this.mapeoFecha();
            // console.log('response estrados',this.data);
        } catch (error) {
            console.log('error v', error.message);
        }
    },
    async mapeoFecha(){
      let fecha_texto = this.data[0].fecha_actualizacion;
      console.log(fecha_texto);

      let day = fecha_texto.slice(0, 2); // Primeros 2 caracteres -> "26"
      let month = fecha_texto.slice(3, 5); // Caracteres 4-5 -> "11"
      let year = fecha_texto.slice(6, 10); // Caracteres 7-10 -> "2024"

      let fecha_formateada = `${year}-${month}-${day}`; // Formato YYYY-MM-DD
      this.fecha_actualizacion = fecha_formateada;

      console.log('fecha TEXT -->', fecha_texto);
      console.log('fecha FORMATEADA -->', fecha_formateada);
      this.fecha_actualizacion = this.DateFormatText(fecha_formateada);
      
    }
  },
watch: {
},
}
</script>
<style scoped>
.contenido-texto p{text-align: justify;}
</style>
